import {getContent} from '../modules/archive-fetch';
import initializeGlider from '../modules/initialize-glider';

export default {
    init() {
      // JavaScript to be fired on all pages
    },
    finalize() {
        const showFilters = document.querySelector('.js-show-filters');
        const filterList = document.querySelector('.js-filters-list');
        
        const filterItems = document.querySelectorAll('.js-filter-item');
        const openGroup = document.querySelectorAll('.js-category-group');
        const parentGroups = document.querySelectorAll('.js-parent-category');
        const filterInputs = document.querySelectorAll('.js-filter input');
        const archiveWrapper = document.querySelector('.Archive__Wrapper');
        
        let idsToFilter = [];

        window.currentPage = 1;
    
        if (showFilters && filterList) {
            showFilters.addEventListener('click', () => {
                filterList.classList.toggle('is-active');
            })
        }
        
    
        if (openGroup) {
            openGroup.forEach( group => {
                group.addEventListener('click', () => {
                    resetAll();
                    if (group.classList.contains('js-parent-category')) {
                        toggleSubgroup(group);
                    }
            
                    if (group.classList.contains('js-all-products')) {
                        updateContent();
                    }

                    activateHeading(group);
                });
            });
        }
    
        if (filterItems) {
            filterItems.forEach( el => {
                el.addEventListener('click', () => {
                // evt.stopPropagation();
        
                if (el.classList.contains('js-whole-category')) {
                    let subgroup_filters = el.parentElement.querySelectorAll('.FilterItem');
                    subgroup_filters.forEach(item => {
                    item.classList.add('is-filter-active');
                    item.querySelector('input').checked = true;
                    })
                }
        
                el.classList.toggle('is-filter-active');
                let currentInput = el.querySelector('input[type="checkbox"');
                if (el.classList.contains('is-filter-active')) {
                    currentInput.checked = true;
                } else {
                    currentInput.checked = false;
                }
        
                checkAllIds();
                updateContent();
                })
            });
        }
    
        const toggleSubgroup = (el) => {
            if (el.classList.contains('is-open')) {
                el.classList.remove('is-open');
            } else {
                openGroup.forEach( group => {
                group.classList.remove('is-open');
                });
                el.classList.add('is-open');
            }
        }

        const activateHeading = (el) => {
            if (el.classList.contains('is-active')) {
                el.classList.remove('is-active');
            } else {
                openGroup.forEach( group => {
                    group.classList.remove('is-active');
                });
                el.classList.add('is-active');
            }
        }
    
        const resetAll = () => {
            window.currentPage = 1;
            clearAllInputs();
            closeGroups();
            checkAllIds();
        }
    
        const closeGroups = () => {
            parentGroups.forEach( parent => {
                parent.classList.remove('is-open')
            });
        }
    
        const clearAllInputs = () => {
            if (filterInputs) {
                filterInputs.forEach(element => {
                    element.parentElement.classList.remove('is-filter-active');
                    element.checked = false;
                });
            }
        }
    
        const checkAllIds = () => {
        filterInputs.forEach(element => {
            if (element.checked) {
            if (!idsToFilter.includes(element.dataset.termid)) {
                idsToFilter.push(element.dataset.termid)
            }
            } else {
            let index = idsToFilter.indexOf(element.dataset.termid);
            if (index > -1) {
                idsToFilter.splice(index, 1);
            }
            }
        });
        console.log('idsToFilter', idsToFilter);
        }

        const updateContent = (ids = null) => {
            ids = ids ? ids : idsToFilter 
            let archiveContent = getContent(ids, 'post', window.currentPage);
            archiveWrapper.classList.add('js-archive-loading');
            archiveContent.then(html => {
                archiveWrapper.innerHTML = html;
                archiveWrapper.classList.remove('js-archive-loading');
                setArrowListeners();
            }).then(() => {
                initializeGlider();
            })
        }
    
        const setArrowListeners = () => {
            const prevPagination = document.querySelector('.Pagination__Arrow--Prev');
            if (prevPagination) {        
            prevPagination.addEventListener('click', (ev) => {
                if(ev.target.classList.contains('is-disabled')){
                return;
                }
                window.currentPage = window.currentPage - 1;
                updateContent();
            });
            }
            const nextPagination = document.querySelector('.Pagination__Arrow--Next');
            if (nextPagination) {        
            nextPagination.addEventListener('click', (ev) => {
                if(ev.target.classList.contains('is-disabled')){
                return;
                }
                window.currentPage = window.currentPage + 1;
                updateContent();
            });
            }
        };
    
        setArrowListeners();
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/blog.js